import React, {useCallback, useMemo, useState} from "react";
import CheckboxTree from "react-checkbox-tree";
import get from "lodash/get";
import {FormControlLabel} from "@material-ui/core";
import Switch from "@material-ui/core/Switch";

export const TreeCheckboxInputV2 = (props) => {
    const {
        input,
        choices = [],
        optionValue = "id",
        optionText = "name",
        labelRender,
        hideDeleted = false,
        optionDeleteProp = "deleted",
        expandTopLevel = false,
        onChecked,
    } = props;

    const [expanded, setExpanded] = useState([-9999]);
    const [checkedAll, setCheckedAll] = useState(false);

    /** ===== HANDLE CHECK ===== */
    const handleChange = useCallback(
        (selectedValues) => {
            input.onChange(selectedValues);
            if (onChecked) {
                onChecked(selectedValues);
            }
        },
        [input, onChecked]
    );


    /** ===== DEDUP ===== */
    const dedupChoices = (items) => {
        const map = new Map();
        items.forEach(item => {
            map.set(get(item, optionValue), item);
        });
        return Array.from(map.values());
    };
    const stableSort = (arr) =>
        [...arr].sort((a, b) =>
            String(a.name).localeCompare(String(b.name))
        );

    /** ===== BUILD TREE ===== */
    const findByParentId = (items, parentId) => {
        return items
            .filter(i =>
                parentId === null
                    ? i.parentId == null // null OR undefined
                    : i.parentId === parentId
            )
            .map(i => ({
                ...i,
                children: findByParentId(items, i.id),
            }));
    };



    /** ===== CONVERT NODE ===== */
    const toTreeCheckboxNode = (choice) => {
        const node = {
            value: get(choice, optionValue),
            label: labelRender?.(choice) || get(choice, optionText),
        };

        if (choice.children?.length) {
            node.children = choice.children.map(toTreeCheckboxNode);
        }

        return node;
    };

    /** ===== FILTER CHOICES ===== */
    const {nodes, expandedNodes, deletedCount} = useMemo(() => {
        const deduped = stableSort(dedupChoices(choices));


        const active = deduped.filter(i => i[optionDeleteProp] !== false);
        const deleted = deduped.filter(i => i[optionDeleteProp] === false);

        const source = checkedAll ? deduped : active;
        const tree = findByParentId(source, null);

        const children = tree.map(toTreeCheckboxNode);
        const topLevelIds = children.map(n => n.value);

        return {
            nodes: [
                {
                    label: "Chọn tất cả",
                    value: -9999,
                    children,
                },
            ],
            expandedNodes: expandTopLevel ? [...expanded, ...topLevelIds] : expanded,
            deletedCount: deleted.length,
        };
    }, [choices, checkedAll, expanded]);

    return (
        <>
            {hideDeleted && (
                <FormControlLabel
                    label="Hiện các mục không sử dụng"
                    control={
                        <Switch
                            checked={checkedAll}
                            style={{pointerEvents: "auto"}}
                            onChange={() => setCheckedAll(v => !v)}
                        />
                    }
                />
            )}

            <CheckboxTree
                nodes={nodes}
                checked={input.value || []}
                onCheck={handleChange}
                expanded={expandedNodes}
                onExpand={setExpanded}
                showNodeIcon={false}
            />

            {hideDeleted && !checkedAll && deletedCount > 0 && (
                <div
                    style={{
                        padding: 8,
                        color: "#999",
                        fontStyle: "italic",
                        position: "sticky",
                        bottom: 0,
                        background: "white",
                    }}
                >
                    ({deletedCount} mục không sử dụng bị ẩn)
                </div>
            )}
        </>
    );
};
